var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text--primary"},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{staticClass:"mx-auto pa-6",attrs:{"elevation":hover ? 24 : 6}},[_vm._v(" Prop based elevation ")])]}}])}),_c('div',{staticClass:"my-6"}),_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('div',{staticClass:"mx-auto pa-6 transition-swing",class:("elevation-" + (hover ? 24 : 6))},[_vm._v(" Class based elevation ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }